/* @flow */
import { Map } from 'immutable';
import {
  SET_ENCLAVE_MENU,
  SELECT_DEFAULT_ENCLAVE,
  SAVE_EMAIL_SETTINGS,
  TIMEZONE_CHANGED,
  FETCH_INGEST_EMAILS,
  DELETE_INGEST_EMAIL,
  EDIT_EMAIL_INGEST,
  CLEAR_EMAIL_INGEST,
  TOGGLE_SELECT_EMAIL_INGEST,
  CLEAR_SELECTED_EMAIL_INGEST,
  CREATE_NEW_EMAIL_INGEST,
  CLOSE_NEW_EMAIL_FORM,
  CANCEL_CONFIRM_DELETE_INGEST_EMAIL,
  CONFIRM_DELETE_INGEST_EMAIL,
  CONFIRM_REQUEST_NEW_INGEST_EMAIL,
  CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL,
} from './action-types.js';

/* Toggle enclave select menu */
export const setEnclaveMenu = (option: boolean): Object => ({
  type: SET_ENCLAVE_MENU,
  payload: option,
});

/* Select a default enclave */
export const selectEnclave = (name: string, id: string): Object => ({
  type: SELECT_DEFAULT_ENCLAVE,
  payload: { name, id },
});

export const saveEmailSettings = (values: Map<any, any>): Object => ({
  type: SAVE_EMAIL_SETTINGS,
  payload: values
});

export const timezoneChanged = (timezone: string) => ({
  type: TIMEZONE_CHANGED,
  payload: timezone,
});

export const fetchIngestEmails = (params: Object) => ({
  type: FETCH_INGEST_EMAILS,
  payload: params,
});

export const deleteIngestEmail = (payload: { guid: string }) => ({
  type: DELETE_INGEST_EMAIL,
  payload,
});

export const editEmailIngest = (payload: { guid: string }) => ({
  type: EDIT_EMAIL_INGEST,
  payload,
});

export const clearEmailIngest = () => ({
  type: CLEAR_EMAIL_INGEST,
});

export const toggleSelectEmailIngest = (payload: { guid: string }) => ({
  type: TOGGLE_SELECT_EMAIL_INGEST,
  payload
});

export const clearSelectedEmailIngests = () => ({
  type: CLEAR_SELECTED_EMAIL_INGEST,
});

export const createNewEmailIngest = () => ({
  type: CREATE_NEW_EMAIL_INGEST,
});

export const closeNewEmailForm = () => ({
  type: CLOSE_NEW_EMAIL_FORM,
});

export const confirmDeleteIngestEmail = () => ({
  type: CONFIRM_DELETE_INGEST_EMAIL,
});

export const cancelConfirmDeleteIngestEmail = () => ({
  type: CANCEL_CONFIRM_DELETE_INGEST_EMAIL,
});

export const requestNewEnclaveInbox = () => ({
  type: CONFIRM_REQUEST_NEW_INGEST_EMAIL,
});

export const cancelRequestNewEnclaveInbox = () => ({
  type: CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL,
});


// WEBPACK FOOTER //
// ./src/app/modules/settings/actions.js